import React, { forwardRef, MutableRefObject } from 'react'
import { Button, type ButtonProps } from '@paypalcorp/pp-react' // eslint can't see ButtonProps
import { buttonFullWidthCss } from './ButtonFullWidth.css'

interface Props extends ButtonProps {
  children: React.ReactNode
}

/**
 * This wrapper returns a Button whose style is set to 100%
 */
const ButtonFullWidth = (
  props: Props,
  ref: MutableRefObject<HTMLButtonElement | HTMLAnchorElement>,
) => {
  return (
    <Button
      {...props}
      className={buttonFullWidthCss}
      size="lg"
      fullWidthOnMobile
      ref={ref}
    >
      {props.children}
    </Button>
  )
}

export default forwardRef(ButtonFullWidth)
